import { Cookies } from 'react-cookie';

import { TotalTrapsCaptureChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTotalTrapsCaptureChart = async (slug: string, period: string, start_date: string, end_date: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/analitycs/traps-compare-captures/${slug}/${period}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_datetime: start_date,
      end_datetime: end_date,
    },
  });
  return data.data as TotalTrapsCaptureChartData;
};
